import {useRef, useCallback} from 'react';
import {pushModal, popModal} from './state';

export const useModalTask = <TResult, TProps = any>(
  Component: React.FC<TProps>,
) => {
  const promiseResolveRef = useRef<(success: TResult) => void>();

  return useCallback(
    (props: TProps) => {
      // Set up promise with callback
      const promise = new Promise<TResult>(resolve => {
        promiseResolveRef.current = resolve;
      });

      // Callback handler with promise
      const callback = (success: TResult) => {
        // Dismiss dialog
        popModal();
        // Resolve promise
        promiseResolveRef.current && promiseResolveRef.current(success);
      };

      // Push alert
      pushModal<TProps, TResult>(callback, Component, {...props, callback});

      // Return promise that will return on callback
      return promise;
    },
    [Component],
  );
};
